import PropTypes from "prop-types";
import { formats } from "investira.sdk";

/**
 * Renderiza o componente FormatNumber.
 *
 * @param {Object} props - Propriedades do componente.
 * @param {number} props.value - Valor exibido ou controlado pelo componente.
 * @param {number} props.decimal - Propriedade `decimal` do componente.
 * @param {boolean} props.separateThousand - Propriedade `separateThousand` do componente.
 * @param {boolean} props.showCurrency - Propriedade `showCurrency` do componente.
 * @param {string} props.sufix - Propriedade `sufix` do componente.
 * @returns {JSX.Element} Elemento renderizado pelo componente.
 */
const FormatNumber = props => {
  const {
    value = 0,
    decimal = 6,
    separateThousand = true,
    showCurrency = false,
    sufix = ""
  } = props;
  return `${formats.formatNumber(value, decimal, separateThousand, showCurrency)}${sufix}`;
};
FormatNumber.propTypes = {
  value: PropTypes.number,
  decimal: PropTypes.number,
  separateThousand: PropTypes.bool,
  showCurrency: PropTypes.bool,
  sufix: PropTypes.string
};
export default FormatNumber;
